import * as React from 'react';
import { Input as HenInput } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLabel,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/** GF field type → native HTML input type. */
const INPUT_TYPE_BY_FIELD: Record<string, string> = {
  TEXT: 'text',
  EMAIL: 'email',
  PHONE: 'tel',
  NUMBER: 'number',
  DATE: 'date',
};

/** Single-line inputs: TEXT, EMAIL (email), PHONE (tel), NUMBER (number), DATE (date). */
export function InputField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);
  const type = INPUT_TYPE_BY_FIELD[field.type] ?? 'text';

  return (
    <>
      <FieldLabel field={field} htmlFor={name} />
      <HenInput
        id={name}
        name={name}
        type={type}
        placeholder={field.placeholder}
        required={Boolean(field.isRequired)}
        error={Boolean(error)}
      />
      <FieldErrorMessage error={error} />
    </>
  );
}
